export default class CreateSaleOrderLineDto {
    orderNo:number;
    sku: string;
    productId:number;
    productName:string;
    assetTypeCode: string;
    conditionTypeCode: string;
    orderQty: number;
    productPrice:number;
    price: number;
    vatPercent: number;
    configPrice:number;
    warehouseCode: string;
    qty:number;
}